/* Mock routes — Learn (facts and rewarded quizzes). */

import type { Lesson, Quiz } from '@core/types'
import { ApiError } from '../../http'
import { db } from '../store'
import { asRecord, type MockRoute } from '../types'
import { awardPoints } from './shared'

export const learnRoutes: MockRoute[] = [
  {
    method: 'GET',
    pattern: '/learn/lessons',
    handler: () => db.lessons,
    emptyState: [] satisfies Lesson[],
  },
  {
    method: 'GET',
    pattern: '/learn/quizzes',
    handler: () => db.quizzes,
    emptyState: [] satisfies Quiz[],
  },
  {
    method: 'POST',
    pattern: '/learn/quizzes/:id/submit',
    handler: ({ params, body }) => {
      const quiz = db.quizzes.find((item) => item.id === params.id)
      if (!quiz) {
        throw new ApiError({
          status: 404,
          code: 'quiz_not_found',
          message: 'That quiz is no longer available.',
        })
      }

      const answers = asRecord(asRecord(body).answers)
      const results = quiz.questions.map((question) => {
        const given = typeof answers[question.id] === 'string' ? String(answers[question.id]) : null
        return {
          questionId: question.id,
          prompt: question.prompt,
          givenOptionId: given,
          correctOptionId: question.correctOptionId,
          isCorrect: given === question.correctOptionId,
          explanation: question.explanation,
        }
      })

      const correct = results.filter((result) => result.isCorrect).length
      const answeredAll = results.every((result) => result.givenOptionId !== null)
      if (!answeredAll) {
        throw new ApiError({
          status: 422,
          code: 'incomplete_quiz',
          message: 'Answer every question before submitting.',
        })
      }

      const ratio = correct / results.length
      const pointsAwarded = Math.round(quiz.rewardPoints * ratio)
      if (pointsAwarded > 0) {
        awardPoints(
          pointsAwarded,
          `Quiz: ${quiz.title} (${correct} of ${results.length} correct)`,
          'quiz',
        )
      }

      return {
        quizId: quiz.id,
        correct,
        total: results.length,
        ratio,
        pointsAwarded,
        results,
        account: db.rewardAccount,
      }
    },
  },
]
